import _ from 'lodash';
import { required, minLength } from 'vuelidate/lib/validators';
import ToolkitMixin from '@/app/mixins/toolkit/item';
import InvStratDiversification from '@/app/modules/toolkit/inv-strat/components/inv-strat-diversification/inv-strat-diversification.vue';

export default {
  name: 'inv-strat-diversifications',
  components: {
    InvStratDiversification,
  },
  mixin: [ToolkitMixin],
  data: () => ({
    selectedAsset: 0,
  }),
  computed: {
    diversified() {
      return this.$store.getters['toolkit/getItemData'].diversified;
    },
    assets() {
      const { assets } = this.diversified;
      if (assets[this.selectedAsset] === undefined) {
        this.selectedAsset = 0;
      }
      return assets;
    },
  },
  methods: {
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleAssetSelection(event, pos) {
      const changeAsset = _.cloneDeep(this.assets).filter((asset, idx) => idx === pos)[0];
      if (changeAsset.selection !== event) {
        changeAsset.selection = event;
        changeAsset.risks = [];
        changeAsset.considerations = [];
        this.updateAssets(changeAsset);
      }
    },
    handleRiskSelections(event, pos) {
      const changeAsset = _.cloneDeep(this.assets).filter((asset, idx) => idx === pos)[0];
      changeAsset.risks = event;
      this.updateAssets(changeAsset);
    },
    handleConsiderationSelections(event, pos) {
      const changeAsset = _.cloneDeep(this.assets).filter((asset, idx) => idx === pos)[0];
      changeAsset.considerations = event;
      this.updateAssets(changeAsset);
    },
    updateAssets(changeAsset) {
      const { diversified } = this;
      const updatedDiversified = {
        diversified: diversified.diversified,
        assets: this.assets.map((asset) => {
          if (asset.asset === changeAsset.asset) {
            return changeAsset;
          }
          return asset;
        }),
      };
      this.$store.dispatch('toolkit/updateItemKey', {
        data: {
          diversified: updatedDiversified,
        },
      });
    },
  },
  validations: {
    assets: {
      $each: {
        selection: {
          required,
          minLength: minLength(2),
        },
        risks: {
          required,
        },
        considerations: {
          required,
        },
      },
    },
  },
};
